import {
  Archive02Icon,
  Calendar02Icon,
  ClipboardIcon,
  UserGroupIcon,
  User03Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const SALES_NAV_ITEMS: NavItem[] = [
  { title: 'Sales Requests', icon: Archive02Icon, route: '/app/sales/sales-requests' },
  { title: 'Reservations', icon: Calendar02Icon, route: '/app/sales/reservations' },
  {
    title: 'Sales Return Requests',
    icon: ClipboardIcon,
    route: '/app/sales/return-requests',
    devFeature: true,
    isVisible: (baselineKey) =>
      baselineKey === 'SalesSupervisor' || baselineKey === 'SalesCommercialManager',
  },
  // {
  //   title: 'CRM',
  //   icon: UserGroupIcon,
  //   isVisible: (baselineKey) =>
  //     baselineKey === 'AgencyManager' ||
  //     baselineKey === 'AgencyRepresentative' ||
  //     baselineKey === 'SalesSupervisor' ||
  //     baselineKey === 'SalesCommercialManager',
  //   children: [
  //     {
  //       title: 'Test Drive',
  //       route: '/app/sales/crm/test-drives',
  //       devFeature: true,
  //     },
  //     {
  //       title: 'Follow-ups',
  //       devFeature: true,
  //       route: '/app/sales/crm/follow-ups',
  //       isVisible: (baselineKey) =>
  //         baselineKey === 'AgencyManager' ||
  //         baselineKey === 'AgencyRepresentative' ||
  //         baselineKey === 'SalesCommercialManager' ||
  //         baselineKey === 'SalesSupervisor',
  //     },
  //   ],
  // },
  {
    title: 'VIN List',
    icon: ClipboardIcon,
    route: '/app/sales/vin-list',
    isVisible: (baselineKey) =>
      baselineKey === 'AgencyRepresentative' ||
      baselineKey === 'SalesSupervisor' ||
      baselineKey === 'AgencyManager' ||
      baselineKey === 'SalesCommercialManager',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/sales/notifications',
  },
];
